import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useUIContext from '../ui/use-ui-context';

/**
 * Returns a callback that scrolls to the top of the page or a custom scrollbar.
 */
export const useScrollToTopCallback = (behavior?: ScrollBehavior) => {
	const { scrollbar } = useUIContext();
	const callback = useCallback(() => {
		if (scrollbar?.current?.scrollToTop) {
			scrollbar.current.scrollToTop();
		} else {
			window.scrollTo({ top: 0, left: 0, behavior });
		}
	}, [behavior, scrollbar]);
	return callback;
};

/**
 * Scrolls to top on mount and every time path changes
 */
const useScrollToTop = ({ behavior }: { behavior?: ScrollBehavior } = {}) => {
	const { pathname } = useLocation();
	const scrollToTop = useScrollToTopCallback(behavior);

	useEffect(() => {
		scrollToTop();
	}, [pathname, scrollToTop]);
};

/**
 * Scrolls to top once on mount
 */
export const useScrollToTopOnce = ({ behavior }: { behavior?: ScrollBehavior } = {}) => {
	const scrollToTop = useScrollToTopCallback(behavior);

	useEffect(() => {
		scrollToTop();
	}, [scrollToTop]);
};

export default useScrollToTop;
